import { render, staticRenderFns } from "./Review-QCR.vue?vue&type=template&id=3bfe481c"
import script from "./Review-QCR.vue?vue&type=script&lang=js"
export * from "./Review-QCR.vue?vue&type=script&lang=js"
import style0 from "./Review-QCR.vue?vue&type=style&index=0&id=3bfe481c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports